const state = {
  doctors: null,
  currentAppointment: { videoLink: "", doc_id: "", id: "" },
};

export default {
  namespaced: true,

  state: { ...state },

  mutations: {
    SET_DOCTORS(state, payload) {
      state.doctors = payload;
    },
    SET_CURRENT_APPOINTMENT(state, payload) {
      state.currentAppointment = payload || { videoLink: "", docId: "", id: "" };
    },
  },
};
